import { render, staticRenderFns } from "./CartPreview.vue?vue&type=template&id=0229ee1b&scoped=true"
import script from "./CartPreview.vue?vue&type=script&lang=js"
export * from "./CartPreview.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./CartPreview.vue?vue&type=style&index=0&id=0229ee1b&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./CartPreview.vue?vue&type=style&index=1&id=0229ee1b&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0229ee1b",
  "2dd017d0"
  
)

export default component.exports